//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TaggedObjectCollection.js";
import "../no/BasePart.js";
let d=[[],[[["defaults"],"SetDefaultDataEntryUnits",{},1,0],[[],"GetDefaultDataEntryUnits",{R_:{defaults:''}},0,0],[["defaults"],"SetDefaultObjectInformationUnits",{},1,0],[[],"GetDefaultObjectInformationUnits",{R_:{defaults:''}},0,0],[["name"],"FindObject",{R_:{unit_type:"Unit"}},1,0],[["n_measures"],"GetMeasures",{R_:{measure_names:""}},0,0],[["measure_name","n_unit_types"],"GetMeasureTypes",{R_:{unit_types:"Unit[]"}},1,0],[["measure_name"],"GetBase",{R_:{unit_type:"Unit"}},1,0],[["initial_unit_type","target_unit_type","initial_value"],"Convert",{R_:{output_value:''}},3,0],[["measure_name"],"GetDataEntryUnit",{R_:{unit_type:"Unit"}},1,0],[["measure_name"],"GetObjectInformationUnit",{R_:{unit_type:"Unit"}},1,0]],[]];
SPLM.UnitCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.UnitCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

SPLM.UnitCollection.UnitDefaults = Object.freeze({
    "LbmInLbfDegF" : "LbmInLbfDegF", "LbmFtLbfDegF" : "LbmFtLbfDegF", "GMmNDegC" : "GMmNDegC", "GCmNDegC" : "GCmNDegC", "KgMNRadK" : "KgMNRadK", "KgMmNDegC" : "KgMmNDegC", "KgMNDegK" : "KgMNDegK"});

export default SPLM;